import app from 'flarum/forum/app';
import { extend } from 'flarum/common/extend';
import IndexSidebar from 'flarum/forum/components/IndexSidebar';
import LinkButton from 'flarum/common/components/LinkButton';
import Hashtag from './models/Hashtag';
import HashtagPage from './components/HashtagPage';
import HashtagsPage from './components/HashtagsPage';
import registerMentionable from './registerMentionable';
app.initializers.add('ernestdefoe-hashtags', () => {
  app.store.models.hashtags = Hashtag;
  app.routes.hashtag = {
    path: '/hashtag/:name',
    component: HashtagPage
  };
  app.routes.hashtags = {
    path: '/hashtags',
    component: HashtagsPage
  };

  /**
   * Composer autocomplete. Guarded rather than required: hashtags parse, link
   * and browse perfectly well without flarum/mentions — you just lose the
   * suggestions while typing. The import lives behind this check because
   * `ext:flarum/mentions/…` does not resolve when mentions isn't installed.
   */
  if ('flarum-mentions' in flarum.extensions) {
    registerMentionable();
  }

  /**
   * Discoverability: without an entry point, nobody finds /hashtags.
   *
   * IndexSidebar, not IndexPage — Flarum 2 moved the nav list out of the page
   * component, and extending IndexPage here adds an item to a list nothing
   * renders. Priority -10 puts it below the stock items rather than above
   * "All Discussions".
   */
  extend(IndexSidebar.prototype, 'navItems', function (items) {
    items.add('hashtags', m(LinkButton, {
      href: app.route('hashtags'),
      icon: "fas fa-hashtag"
    }, app.translator.trans('ernestdefoe-hashtags.forum.nav.browse')), -10);
  });
});